<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('tags') }}</span></li>
				</ul>
			</div>
		</div>

		<div id="toolbar" class="toolbar">
			<button id="table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="table_search collapse">
					<div class="row">
						<h4 class="uk-text-normal search_title">
							{{ $t('filter') }}
							<div class="uk-float-right section_settings">
								<span class="uk-collapse" uk-icon="icon: chevron-up; ratio: .8"></span>
							</div>
						</h4>
					</div>
					<div class="row">
						<div id="search-controls">
							<div id="global" class="col-sm-2 colspan-1">
								<label>{{ $t('global') }}</label>
								<br>
								<select class="select attribute-editor">
									<option value="any">{{ $t('any') }}</option>
									<option value="true">{{ $t('true') }}</option>
									<option value="false">{{ $t('false') }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="search_button">
							<button id="search" class="uk-button uk-button-primary uk-button-small">{{ $t('search') }}
							</button>
							<button id="search-clear" class="uk-button uk-button-default uk-button-small">{{
								$t('clear.filters') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('tag.edit') }}</a></li>
				<li><a tabindex="-1">{{ $t('tag.delete') }}</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { TagsManager } from '@/core/administration/TagsManager'
import { resizeTableHeight, Table, toggleSearchForm } from '@/core/support_gui_components/table/table'
import { getLocalizedMessage, removeTabindex, showMessageAlert } from '@/core/shared'
import { bindResetButton } from '@/core/input_controls/button/button'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'

export default {
	name: 'TagManagement',
	metaInfo () {
		return {
			title: this.$t('tags')
		}
	},
	methods: {
		initTagsManager: function (action, tag, companyId, activeAttribute) {
			tagsManager.setProperties({
				action: action,
				activeAttribute: activeAttribute,
				tag: tag,
				companyId: companyId,

				postSaveAction: function () {
					table.initTable()
				}
			})
			tagsManager.initTagsManager(action)
		}
	},
	mounted () {
		let that = this
		window.tagsManager = new TagsManager(false)
		let tableColumns = [
			{
				'checkbox': true
			},
			{
				'title': 'name',
				'columnName': 'name',
				'attribute': 'name'
			},
			{
				'title': 'global',
				'columnName': 'global',
				'attribute': 'company_id'
			}
		]

		window.itemStructure = {
			'phase': { 'type': 'S' },
			'global': { 'type': 'B' }
		}

		let companyId = 'company/' + this.$store.getters.getProfile.companyId + '/'

		this.$store.dispatch(USER_CONFIG, 'tagsTable.tableState')
			.then((config) => {
				window.table = new Table('tagsTable', {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						cellsSelectionsSupport: true,
						itemsSelectionsSupport: true,
						restoringSupport: true,
						filterPreProcessor: function (filter) {
							var newFilter = {}
							for (var fieldName in filter) {
								newFilter[fieldName] = filter[fieldName]['val']
							}
							return newFilter
						}
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								console.log(item);
								if (item.companyId == null) {
									showMessageAlert(that.$t('tag.global.not-admin-edit.error'), 'warning')
									return
								}
								that.initTagsManager('edit', item, item.companyId, attribute)
							},
							2: function (item, attribute) {
								if (item.companyId == null) {
									showMessageAlert(that.$t('tag.global.not-admin-delete.error'), 'warning')
									return
								}
								tagsManager.deleteTag(item, table)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								table.callbacks.contextMenu['1'](item, table.selectedAttribute)
							}
						}
					},
					function (data) {
						_.each(data, function (value) {
							value.global = getLocalizedMessage(value.companyId == null)
						})
					}
				)
				table.setSavedState(config)
				table.setDataUrl(window.urlContext + companyId + 'tags/load')
				table.setDataIDsUrl(window.urlContext + companyId + 'tags/ids')
				table.setDataSortUrl(window.urlContext + companyId + 'tags/sort')
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
				initFilterForm(itemStructure, table)
				enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })
				enableHotkeyForSearch(itemStructure, table)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG tagsTable', error)
			})



		$('#table_toolbar_search').bind('click', toggleSearchForm)
		$('#table_toolbar_add').click(function () {
			that.initTagsManager('create', '', that.$store.getters.getProfile.companyId, '')
		})

		$(window).resize(function() {
			resizeTableHeight();
		});
	}
}
</script>

<style scoped>

</style>
